var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_1602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0C4.34375 0 3 1.34375 3 3V8C3 9.65625 4.34375 11 6 11C7.65625 11 9 9.65625 9 8V3C9 1.34375 7.65625 0 6 0ZM2 6.75C2 6.33437 1.66562 6 1.25 6C0.834375 6 0.5 6.33437 0.5 6.75V8C0.5 10.7844 2.56875 13.0844 5.25 13.45V14.5H3.75C3.33437 14.5 3 14.8344 3 15.25C3 15.6656 3.33437 16 3.75 16H6H8.25C8.66562 16 9 15.6656 9 15.25C9 14.8344 8.66562 14.5 8.25 14.5H6.75V13.45C9.43125 13.0844 11.5 10.7844 11.5 8V6.75C11.5 6.33437 11.1656 6 10.75 6C10.3344 6 10 6.33437 10 6.75V8C10 10.2094 8.20937 12 6 12C3.79063 12 2 10.2094 2 8V6.75Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_1602"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V16H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMic);
export default __webpack_public_path__ + "static/media/ic_mic.5b3f2d536c1ba34cae83dc239d2adacf.svg";
export { ForwardRef as ReactComponent };